import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ImportAndExportDataFilter } from '../../model/importAndExportDataFilter';
import { FileImportExportService } from '../../service/file-import-export.service';
import { SelectedVersion } from '../../model/SelectedVersionList';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
const apiControl = '/kam-region';

@Component({
  selector: 'app-kam-region',
  templateUrl: './kam-region.component.html',
  styleUrls: ['./kam-region.component.sass']
})
export class KamRegionComponent implements OnInit {
  dataSetExportImportTable: any; 
  importAndExportDataFilter: ImportAndExportDataFilter = new ImportAndExportDataFilter();
  dtOptionsExportImportTable: DataTables.Settings = {};
  selectedValueList: Array<SelectedVersion> = [];
  selectedValue: SelectedVersion = new SelectedVersion();


  constructor(private http: HttpClient, private fileImportExportService: FileImportExportService, private spinner: NgxSpinnerService, private loggingService: LoggingService) {
    this.dataSetExportImportTable = [];

    fileImportExportService.http = http;
    fileImportExportService.spinner = spinner;
    fileImportExportService.apiControl = apiControl;
    fileImportExportService.downloadFileName = "KAM-Region.xlsx";
  }

  fileToUpload: File = null;

  onImport(event) {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.KamRegionComponent.onImport', null, 'Import started');
    
    this.fileImportExportService.onImport(event).then((data:any)=> {
      this.onFieldChange({ author:"", version:undefined });
      this.loggingService.logFinish(_xid, 'App.Components.KamRegionComponent.onImport', null, 'Import completed');
    }).catch(error => {
      this.loggingService.logError(_xid, 'App.Components.KamRegionComponent.onImport', error, null, 'Import failed');
    });
  }

  downLoadFile(data: any, type: string) {
    this.fileImportExportService.downLoadFile(data, type);
  }

   fileExport(event) {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.KamRegionComponent.fileExport', null, 'Export started');
      this.fileImportExportService.fileExport();
      this.loggingService.logFinish(_xid, 'App.Components.KamRegionComponent.fileExport', null, 'Export completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.KamRegionComponent.fileExport', _error, null, 'Export failed');
      throw _error;
    }
  }
  
  fileExportExample(event) {
    this.fileImportExportService.fileExportExample(event);
  }

  onFieldChange(event): void {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.KamRegionComponent.onFieldChange', null, 'Field change started');
      this.selectedValue = event;
      var table = $('#exportImportTable').DataTable();
      table.draw();
      this.loggingService.logFinish(_xid, 'App.Components.KamRegionComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.KamRegionComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  ngOnInit() {

    this.spinner.show();

    this.fileImportExportService.updateVisibilytyFieldFromeRole();
    
    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 215px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

         dataTablesParameters.search = this.importAndExportDataFilter.search;
         if(this.selectedValue != undefined && this.selectedValue.version != "")
         dataTablesParameters.version = this.selectedValue.version;

        this.http.post<any>(apiServer + apiControl, dataTablesParameters, {})
          .subscribe(resp => {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data:  resp.data
            });
            this.spinner.hide();
          });
        },
        columns: [
          { "data": "number", "width":"10px" },
          { "data": "federalDistrict" },
          { "data": "region" },
          { "data": "user" },
          { "data": "comment" },
          { "data": "fm" }
      ]
      };


    this.http.get<Array<SelectedVersion>>(apiServer + "/versioninfo" + "/Region")
    .subscribe(resp => {
      this.selectedValueList[0] = { author:"", version:"" }
      for (let index = 0; index < resp.length; index++) {
        this.selectedValueList[index + 1] = resp[index];
      }
    });
    
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/kam-region/kam-region.component.ts